import { CustomerDetailsState } from '../../models/CustomerDetails';
import { CustomerDetailActionTypes, CustomerDetailedAction } from './types';

export const customerDetailsInitialState: CustomerDetailsState = {
  loading: true,
  kit: undefined,
  profile: undefined,
  pdfLink: '',
  error: undefined,
};

const CustomerDetailReducers = (state = customerDetailsInitialState, action: CustomerDetailedAction): CustomerDetailsState => {
  switch (action.type) {
    case CustomerDetailActionTypes.START_FETCHING_KITS:
      return {
        ...state,
        loading: true,
      };
    case CustomerDetailActionTypes.FETCH_KITS_SUCCESS:
      return {
        ...state,
        kit: action.payload,
      };
    case CustomerDetailActionTypes.FETCH_PROFILES_SUCCESS:
      return {
        ...state,
        loading: false,
        profile: action.payload,
      };
    case CustomerDetailActionTypes.ACTION_RESET_CUSTOMER_DETAILS:
      return {
        ...state,
        loading: false,
        kit: undefined,
        profile: undefined,
        pdfLink: '',
        error: undefined,
      };
    case CustomerDetailActionTypes.ACTION_USER_PROFILE_DOWNLOAD_REPORT_SUBMIT:
      return {
        ...state,
      };
    case CustomerDetailActionTypes.ACTION_USER_PROFILE_DOWNLOAD_REPORT_SUBMIT_SUCCESS:
      return {
        ...state,
        pdfLink: action.payload.pdf,
      };
    case CustomerDetailActionTypes.ACTION_USER_PROFILE_DOWNLOAD_REPORT_SUBMIT_ERROR:
      return {
        ...state,
        error: action.error,
      };
  }
  return state;
};
export default CustomerDetailReducers;